var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("MyLayout", {
    staticClass: "my-dialog-panel",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      north: {
        height: _vm.headerHeight
      },
      south: {
        height: _vm.footerHeight
      }
    },
    scopedSlots: _vm._u([{
      key: "north",
      fn: function fn() {
        return [_c("div", {
          ref: "header",
          staticClass: "my-dialog-panel__header"
        }, [_c("div", {
          staticClass: "my-dialog-panel__title"
        }, [_vm.icon ? _c("span", {
          staticClass: "my-dialog-panel__icon"
        }, [_vm._t("icon", function () {
          return [_c("MyIcon", _vm._b({}, "MyIcon", _vm.icon, false))];
        })], 2) : _vm._e(), _vm._t("title", function () {
          return [_vm._v(" " + _vm._s(_vm.title) + " ")];
        })], 2), _c("div", {
          staticClass: "my-dialog-panel__tool"
        }, [_vm._t("tool"), _vm.minimizable ? _c("svg-icon", {
          staticClass: "icon-minimize",
          attrs: {
            "icon-class": "icon-dialog-minimize"
          },
          on: {
            click: _vm.handleMinimized
          }
        }) : _vm._e(), _vm.maximizable && !_vm.maximized ? _c("svg-icon", {
          staticClass: "icon-maximize",
          attrs: {
            "icon-class": "fullscreen"
          },
          on: {
            click: function click($event) {
              return _vm.handleMaximized(true);
            }
          }
        }) : _vm._e(), _vm.maximizable && _vm.maximized ? _c("svg-icon", {
          staticClass: "icon-window",
          attrs: {
            "icon-class": "exit-fullscreen"
          },
          on: {
            click: function click($event) {
              return _vm.handleMaximized(false);
            }
          }
        }) : _vm._e(), _vm.closable ? _c("i", {
          staticClass: "el-icon-close",
          attrs: {
            "icon-class": "icon-dialog-close",
            svg: ""
          },
          on: {
            click: _vm.handleClose
          }
        }) : _vm._e()], 2)])];
      },
      proxy: true
    }, _vm.footer ? {
      key: "south",
      fn: function fn() {
        return [_c("div", {
          staticClass: "my-dialog-panel__footer dialog-footer"
        }, [_vm._t("footer", function () {
          return [_vm.submitVisible ? _c("ElButton", {
            attrs: {
              type: "primary",
              size: "small",
              loading: _vm.submitLoading
            },
            on: {
              click: _vm.handleSubmit
            }
          }, [_vm._v(_vm._s(_vm.submitText) + " ")]) : _vm._e(), _c("ElButton", {
            attrs: {
              size: "small"
            },
            on: {
              click: _vm.handleCancel
            }
          }, [_vm._v(_vm._s(_vm.cancelText))])];
        })], 2)];
      },
      proxy: true
    } : null], null, true)
  }, [_c("div", {
    staticClass: "my-dialog-panel__main",
    class: _vm.classes
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };